import { render, staticRenderFns } from "./DocsDetailFunction.vue?vue&type=template&id=71247eac&"
import script from "./DocsDetailFunction.vue?vue&type=script&lang=js&"
export * from "./DocsDetailFunction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports